import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(username) {
  return yield oncallFetch("/api/oncall/partners/users/enable", { username });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/users/enable.js